import hmacSHA1 from 'crypto-js/hmac-sha1'

export function signature(params){
  params = objKeySort(params);
  var keys = Object.keys(params);
  var value = "";
  for (var i = 0; i < keys.length; i++) {
    var _key = keys[i];
    if (value) {
      value += "&"
      }
      value += _key + '=' + params[_key];
    }
      var sign = hmacSHA1(value, 'afGB#xoHnZS!WbtWSzIOmHxot^pRNQeP').toString();
      params['signature'] = sign;
      return params;
}

function objKeySort(obj) {
  var newkey = Object.keys(obj).sort();
  var newObj = {};
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = obj[newkey[i]];
  }
  return newObj;
};


// WEBPACK FOOTER //
// ./src/assets/api/common.js